import { Checkbox, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { LargeButton } from "../Button/Button";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import BitcoinJourneyService, {
  AgreementType,
} from "@services/BitcoinJourney.service";
import successTick from "./images/succes-tick.png";
import store from "@features/store";
import { setApiMe } from "@features/action.bfapp";

type ShareEmailModalProps = {
  open?: boolean;
  onClose?: () => void;
  isUk?: boolean;
};

const globalSuccessText = (
  <>
    <p>
      Once you confirm by email, you’ll officially become a member of the
      Bitcoin Wealth Builder Program.
    </p>
    <p>
      Get ready to embark on a journey focused on building and protecting your
      Bitcoin wealth.
    </p>
    <p>
      An email from&nbsp;{" "}
      <a
        href="http://simondixon.com/"
        target="_blank"
        className="underline font-semibold"
      >
        SimonDixon.com
      </a>
      &nbsp;with your login details will arrive shortly. Please note, this login
      will be independent of your Bnk To The Future account.
    </p>
  </>
);

const ukSuccessText = (
  <>
    <p>
      Once you confirm by email, you’ll officially become a member of the
      Bitcoin Wealth Builder Program.
    </p>
    <p>
      Get ready to embark on a journey focused on building and managing your
      Bitcoin wealth.
    </p>
    <p>
      An email from&nbsp;{" "}
      <a
        href="http://simondixon.com/"
        target="_blank"
        className="underline font-semibold"
      >
        SimonDixon.com
      </a>
      &nbsp;with your login details will arrive shortly. Please note that this
      login is separate from your Bnk To The Future account.
    </p>
  </>
);

export const ShareEmailModal = ({
  open,
  onClose,
  isUk,
}: ShareEmailModalProps) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    agreement1: false,
    agreement2: false,
    agreement3: false,
    agreement4: false,
  });

  useEffect(() => {
    setIsSuccess(false);
    setCheckboxes({
      agreement1: false,
      agreement2: false,
      agreement3: false,
      agreement4: false,
    });
  }, [open]);

  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    const { id, checked } = e.target;
    setCheckboxes((prev) => ({
      ...prev,
      [id ?? "agreemnt"]: checked,
    }));
  };

  const handleSubmit = async () => {
    try {
      await BitcoinJourneyService.acceptAgreement(AgreementType.StepThree);
      store.dispatch(setApiMe(true));

      setIsSuccess(true);
    } catch (e) {
      console.log(e);
    }
  };

  const allChecked = Object.values(checkboxes).every((checked) => checked);

  return (
    <Modal
      className="tailwind-modal"
      open={open}
      closable
      onCancel={onClose}
      footer={null}
    >
      <div className="tailwind">
        <h5 className="text-[#24052B]">
          {isSuccess ? "You’re almost there!" : "Share email and grant access"}
        </h5>

        {!isSuccess && (
          <div>
            <div className="mt-[40px]">
              <div className="mb-6">
                <Checkbox
                  id="agreement1"
                  checked={checkboxes.agreement1}
                  onChange={handleCheckboxChange}
                >
                  <label className="normal-case" htmlFor="agreement1">
                    I agree to give permission to share my name, email address,
                    and country with{" "}
                    <a
                      href="https://www.simondixon.com/"
                      target="_blank"
                      className="underline font-semibold"
                    >
                      www.SimonDixon.com
                    </a>
                  </label>
                </Checkbox>
              </div>

              <div className="mb-6">
                <Checkbox
                  id="agreement2"
                  checked={checkboxes.agreement2}
                  onChange={handleCheckboxChange}
                >
                  <label className="normal-case" htmlFor="agreement2">
                    I agree to the www.SimonDixon.com{" "}
                    <a
                      href="https://www.simondixon.com/terms-of-use"
                      target="_blank"
                      className="underline font-semibold"
                    >
                      Terms of Use
                    </a>
                  </label>
                </Checkbox>
              </div>

              <div className="mb-6">
                <Checkbox
                  id="agreement3"
                  checked={checkboxes.agreement3}
                  onChange={handleCheckboxChange}
                >
                  <label className="normal-case" htmlFor="agreement3">
                    I agree to the www.SimonDixon.com{" "}
                    <a
                      href="https://www.simondixon.com/privacy-policy"
                      target="_blank"
                      className="underline font-semibold"
                    >
                      Privacy Policy
                    </a>
                  </label>
                </Checkbox>
              </div>

              <Checkbox
                id="agreement4"
                checked={checkboxes.agreement4}
                onChange={handleCheckboxChange}
              >
                <label className="normal-case" htmlFor="agreement4">
                  I have read and understood the{" "}
                  <a
                    href="https://www.simondixon.com/disclaimer"
                    target="_blank"
                    className="underline font-semibold"
                  >
                    Disclaimer
                  </a>{" "}
                  on www.SimonDixon.com
                </label>
              </Checkbox>
            </div>

            <LargeButton
              onClick={handleSubmit}
              className="block mt-[40px]"
              disabled={!allChecked}
            >
              Confirm
            </LargeButton>
          </div>
        )}

        {isSuccess && (
          <div>
            <div className="my-[40px]">
              {isUk ? ukSuccessText : globalSuccessText}
            </div>
            <div className="flex justify-center">
              <img
                src={successTick}
                alt="success tick"
                className="h-[130px] w-[130px]"
              />
            </div>

            <LargeButton className="block mt-[40px]" onClick={onClose}>
              Back to Page
            </LargeButton>
          </div>
        )}
      </div>
    </Modal>
  );
};
